module.exports = __webpack_public_path__ + "static/media/Monteur_mit_heykitchen_app.33c00525.webp";